import { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import DataTableExtensions from 'react-data-table-component-extensions';
import OverflowMenu from '../../components/OverflowMenu';
import Spinner from '../../components/Spinner';
import { fetchAllCategories } from '../../api';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { InstitutionCategory } from '../../@types/institution';

const Categories = () => {
  const [data, setData] = useState<Array<InstitutionCategory> | null>(null);

  useEffect(() => {
    fetchAllCategories().then((data: any) => {
      setData(data);
    });
  }, []);

  const columns = [
    { name: 'ID', selector: (row: InstitutionCategory) => row.id ?? '', sortable: true, maxWidth: '40px' },
    { name: 'Name', selector: (row: InstitutionCategory) => row.display_name, sortable: true, maxWidth: '180px' },
    { sortable: false, button: true, cell: (row: InstitutionCategory) => <OverflowMenu type="category" id={row.id} /> },
  ];

  return (
    <div className="ms-content-wrapper">
      <div className="ms-panel">
        <div className="ms-panel-header d-flex justify-content-between align-items-center">
          <h6>Categories</h6>
          <Link to={`/category/add`}>
            <Button variant="primary">Add</Button>
          </Link>
        </div>
        <div className="ms-panel-body">
          {!data && <Spinner />}
          {data && (
            <div className="table-responsive datatables row">
              <DataTableExtensions {...{ columns, data }} export={false} print={false}>
                <DataTable columns={columns} data={data} pagination responsive={true} highlightOnHover noHeader />
              </DataTableExtensions>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Categories;
